export default __webpack_public_path__ + "static/home-hero-stage-39b98bef83643f1f3fac7360c92fa8d3.webp";